import React from "react";
import { Button, OverlayTrigger, Popover } from "react-bootstrap";
import MaterialTotalsContent from "./MaterialTotalsContent";

const MaterialTotals = ({ materialEnabled, onToggleMaterial, ...props }) => {
  return (
    <OverlayTrigger
      placement="bottom"
      rootClose
      trigger={["hover", "focus"]}
      overlay={
        <Popover id="materialPopover" title="Material Totals">
          <MaterialTotalsContent {...props} />
        </Popover>
      }
    >
      <Button
        active={materialEnabled}
        bsStyle="default"
        onClick={onToggleMaterial}
      >
        Material
      </Button>
    </OverlayTrigger>
  );
};

export default MaterialTotals;
